import React, { useState, useEffect } from 'react';
import './Bracket.css';
import { getBracketData } from '../../services/MatchService';
import { BracketData } from '../../models/BracketData';
import { currentSeason } from '../../Constants';
import { Link } from 'react-router-dom';

const Bracket: React.FC = () => {
    const [bracketData, setBracketData] = useState<BracketData | null>(null);

    useEffect(() => {
        const fetchData = async () => {
            const data = await getBracketData(currentSeason);
            setBracketData(data);
        };

        fetchData();
    }, []);

    const calculateWinnerClass = (teamAScore: number | null, teamBScore: number | null, teamType: 'A' | 'B') => {
        if (teamAScore === null || teamBScore === null) return '';
        if (teamType === 'A' && teamAScore > teamBScore) return 'winner';
        if (teamType === 'B' && teamBScore > teamAScore) return 'winner';
        return '';
    };

    if (!bracketData) return <div className='tournament-container'>Loading...</div>;

    return (
        <div className="tournament-container text-center">
            <h1 className="tournament-title">Double Elimination Tournament Bracket</h1>
            <div className="bracket">
                <div className="bracket-section upper-bracket">
                    <h2>Upper Bracket</h2>
                    <div className="round-wrapper">
                        {bracketData.upperBracket.map((round) => (
                            <div className="round-container" key={`upper-round-${round.roundNumber}`}>
                                <h3>Round {round.roundNumber}</h3>
                                <div className="round">
                                    {round.matches.map((match, idx) => (
                                        <div className="match-container m-3" key={`upper-match-${round.roundNumber}-${idx}`}>
                                            <div className="match">
                                                <div className={`team ${calculateWinnerClass(match.teamAScore, match.teamBScore, 'A')}`}>
                                                    {match.teamA ? (
                                                        <Link to={`/team/${match.teamA.teamId}`} className="text-decoration-none">
                                                            <img src={match.teamA.teamLogo} width={40} height={40} alt={match.teamA.teamName} />
                                                            {match.teamA.teamName}
                                                        </Link>
                                                    ) : 'TBD'}
                                                </div>
                                                <div className={`team ${calculateWinnerClass(match.teamAScore, match.teamBScore, 'B')}`}>
                                                    {match.teamB ? (
                                                        <Link to={`/team/${match.teamB.teamId}`} className="text-decoration-none">
                                                            <img src={match.teamB.teamLogo} width={40} height={40} alt={match.teamB.teamName} />
                                                            {match.teamB.teamName}
                                                        </Link>
                                                    ) : 'TBD'}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}

                        {/* Grand Final Positioned to the Right */}
                        {bracketData.finalMatch && (
                            <div className="bracket-section grand-final">
                                <h2>Grand Final</h2>
                                <div className="round match-container">
                                    <div className="match">
                                        <div className={`team ${calculateWinnerClass(bracketData.finalMatch.teamAScore, bracketData.finalMatch.teamBScore, 'A')}`}>
                                            {bracketData.finalMatch.teamA ? (
                                                <Link to={`/team/${bracketData.finalMatch.teamA.teamId}`} className="text-decoration-none">
                                                    <img src={bracketData.finalMatch.teamA.teamLogo} width={40} height={40} alt={bracketData.finalMatch.teamA.teamName} />
                                                    {bracketData.finalMatch.teamA.teamName}
                                                </Link>
                                            ) : 'TBD'}
                                            {bracketData.finalMatch.teamAScore !== null && <span className="score"> - {bracketData.finalMatch.teamAScore}</span>}
                                        </div>
                                        <div className={`team ${calculateWinnerClass(bracketData.finalMatch.teamAScore, bracketData.finalMatch.teamBScore, 'B')}`}>
                                            {bracketData.finalMatch.teamB ? (
                                                <Link to={`/team/${bracketData.finalMatch.teamB.teamId}`} className="text-decoration-none">
                                                    <img src={bracketData.finalMatch.teamB.teamLogo} width={40} height={40} alt={bracketData.finalMatch.teamB.teamName} />
                                                    {bracketData.finalMatch.teamB.teamName}
                                                </Link>
                                            ) : 'TBD'}
                                            {bracketData.finalMatch.teamBScore !== null && <span className="score"> - {bracketData.finalMatch.teamBScore}</span>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <div className="bracket-section lower-bracket">
                    <h2>Lower Bracket</h2>
                    <div className="round-wrapper">
                        {bracketData.lowerBracket.map((round) => (
                            <div className="round-container" key={`lower-round-${round.roundNumber}`}>
                                <h3>Round {round.roundNumber}</h3>
                                <div className="round">
                                    {round.matches.map((match, idx) => (
                                        <div className="match-container m-3" key={`lower-match-${round.roundNumber}-${idx}`}>
                                            <div className="match">
                                                <div className={`team ${calculateWinnerClass(match.teamAScore, match.teamBScore, 'A')}`}>
                                                    {match.teamA ? (
                                                        <Link to={`/team/${match.teamA.teamId}`} className="text-decoration-none">
                                                            <img src={match.teamA.teamLogo} width={40} height={40} alt={match.teamA.teamName} />
                                                            {match.teamA.teamName}
                                                        </Link>
                                                    ) : 'TBD'}
                                                </div>
                                                <div className={`team ${calculateWinnerClass(match.teamAScore, match.teamBScore, 'B')}`}>
                                                    {match.teamB ? (
                                                        <Link to={`/team/${match.teamB.teamId}`} className="text-decoration-none">
                                                            <img src={match.teamB.teamLogo} width={40} height={40} alt={match.teamB.teamName} />
                                                            {match.teamB.teamName}
                                                        </Link>
                                                    ) : 'TBD'}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Bracket;
